import React, { useEffect, useRef, useState } from 'react';
import observer from '../utils/observer';

const TrainingCommunityCard = ({
  header,
  text,
  cardClass,
  refValue,
  onCard1,
  setOnCard1,
  onCard2,
  setOnCard2,
  cardDefault,
}) => {
  return (
    <div
      className={`training-community-card ${cardDefault} ${cardClass} ${
        onCard1 ? 'card-2-slide' : ''
      } ${onCard2 ? 'card-3-slide' : ''} `}
      ref={refValue}
      onMouseEnter={() => {
        cardClass.includes('1') && setOnCard1(true);
        cardClass.includes('2') && setOnCard2(true);
      }}
      onMouseLeave={() => {
        cardClass.includes('1') && setOnCard1(false);
        cardClass.includes('2') && setOnCard2(false);
      }}
    >
      <div className="training-community-card-header">{header}</div>
      <div className="training-community-card-text">{text}</div>
    </div>
  );
};

const TrainingCommunity = () => {
  const cardOneRefValue = useRef(null);
  const cardTwoRefValue = useRef(null);
  const cardThreeRefValue = useRef(null);
  const refValue = useRef(null);
  const [onCard1, setOnCard1] = useState(false);
  const [onCard2, setOnCard2] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    observer(refValue, 'section-hidden');
    observer(cardTwoRefValue, 'card-default-state');
    observer(cardThreeRefValue, 'card-default-state');
    setLoaded(true);
  }, [refValue, cardOneRefValue, cardTwoRefValue, cardThreeRefValue]);

  return (
    <div className="training-community-container section-hidden" ref={refValue}>
      <div className="training-community-header-container">
        <div className="training-community-header">
          Endless health possibilities for every individual
        </div>
      </div>
      <div className="training-community-sub-header-container">
        <div className="training-community-sub-header">
          Expert Coaches, Tailored Guidance for Success, and Supportive
          Community
        </div>
      </div>
      <div className="training-community-cards">
        <TrainingCommunityCard
          header={'Experienced Coaches'}
          text={
            'Ignite your fitness journey with a skilled weight loss coach. Benefit from personalized guidance and expert strategies for effective goal achievement'
          }
          cardClass="card-1"
          refValue={cardOneRefValue}
          setOnCard1={setOnCard1}
        />
        <TrainingCommunityCard
          header={'Community Manager'}
          text={
            'Fuel your wellness journey with a dedicated guide. Our Community Manager facilitates connections, answers queries, and ensures a positive community experience, enhancing your path to wellness'
          }
          cardClass="card-2"
          refValue={cardTwoRefValue}
          onCard1={onCard1}
          setOnCard2={setOnCard2}
          cardDefault={loaded ? '' : 'card-default-state'}
        />
        <TrainingCommunityCard
          header={'Weight Loss Community'}
          text={
            'Thrive in a vibrant weight loss community. Connect, share, and gain inspiration from like-minded individuals on a similar journey. Boost your motivation and results with a supportive community'
          }
          cardClass="card-3"
          refValue={cardThreeRefValue}
          onCard2={onCard2}
          cardDefault={loaded ? '' : 'card-default-state'}
        />
      </div>
    </div>
  );
};

export default TrainingCommunity;
